import { HERO_BANNER_COMPONENT_NAME } from 'src/shared/static';
import { B02HeroBannerCarouselProps } from './B02HeroBannerCarousel.types';
import { B01HeroBannerProps } from '../B01HeroBanner/B01HeroBanner.type';
import { GetHeroBannerModel } from '../B01HeroBanner/B01HeroBanner.service';
import { HeroBanner, HeroBannerCarouselProps } from '@ahc-digital/component-library';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export function GetHeroBannerCarouselModel(
  props?: B02HeroBannerCarouselProps
): HeroBannerCarouselProps {
  const slidesArray =
    props?.rendering?.placeholders?.['hero-banner-carousel-container-{*}']?.filter(
      ({ componentName }) => !!componentName && componentName === HERO_BANNER_COMPONENT_NAME
    ) || [];
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );
  const slides =
    slidesArray?.map((s, idx) => {
      const cta = s as unknown as B01HeroBannerProps;
      return (
        <HeroBanner
          key={idx}
          {...GetHeroBannerModel(cta)}
          data-component={marketingRenderingName}
        />
      );
    }) || [];
  const carouselProps = {
    slideTimingSeconds: props?.params?.SlideTiming ?? '6',
    slides: slides,
    shouldLeftAlignOnMobile: !!props?.params?.LeftAlignOnMobile,
  } as HeroBannerCarouselProps;

  return carouselProps;
}
